import script from "./list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-item.vue?vue&type=script&setup=true&lang=ts"

import "./list-item.vue?vue&type=style&index=0&id=f25adc7e&lang=postcss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f25adc7e"]])

export default __exports__